import { SxProps, Theme } from '@mui/material'

export const listItemSx: SxProps<Theme> = {
  height: 'auto',
  paddingTop: '0.6rem',
  paddingBottom: '0.6rem',
  maxWidth: 'fit-content',
  '::before': {
    content: '""',
    position: 'absolute',
    top: '1.8rem',
    left: 0,
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '50%',
    backgroundColor: (theme) => theme.palette.primary.main,
  },
}

export const listItemTextSx: SxProps<Theme> = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

export const loadingWrapperSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50vh',
}

export const listSx: SxProps<Theme> = {
  padding: '1.2rem 0 0 1rem',
  marginBottom: '-0.5rem',
}
